module.exports = __webpack_public_path__ + "assets/7aa92673c52b3d295c5457390122a41c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/artwork-4.png
// module id = 389
// module chunks = 1